import React from 'react';
import { handleActions } from 'redux-actions';
import * as ActionTypes from '../../../constants/ActionTypes';
import { merge, set as setPath } from 'lodash';

const initialState = {
    input: {
        size: '16px',
        color: '#000000',
        borderColor: '#CCCCCC',
        style: 'normal',
        weight: 'normal',
        decoration: 'none',
        align: 'left',
        font: 'IBM Plex sans'
    }
};

const formDataReducer = handleActions(
    {
        [ActionTypes.THEME_FORM_SET_THEME_FONT]: (state, action) => {
            let obj = {
                input: {
                    ...state.input
                }
            };
            if (action.layer === 'input') {
                obj['input'] = { ...state['input'], font: action.font };
            }
            obj[action.layer] = { ...state[action.layer], font: action.font };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_FORM_SET_THEME_FONT_SIZE]: (state, action) => {
            let obj = {
                input: {
                    ...state.input
                }
            };
            obj['input'] = { ...state['input'], size: action.size };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_FORM_SET_THEME_FONT_WEIGHT]: (state, action) => {
            let obj = {
                input: {
                    ...state.input
                }
            };
            obj['input'] = { ...state['input'], weight: action.weight };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_FORM_SET_THEME_FONT_COLOR]: (state, action) => {
            let obj = {
                input: {
                    ...state.input
                }
            };
            obj['input'] = { ...state['input'], color: action.color };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_FORM_SET_THEME_BACKGROUND_COLOR]: (state, action) => {
            let obj = {
                input: {
                    ...state.input
                }
            };
            obj['input']['background'] = { ...state['input']['background'] };
            obj['input']['background'] = { ...state['input']['background'], [action.layer]: action.background };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_FORM_SET_THEME_BORDER_COLOR]: (state, action) => {
            let obj = {
                input: {
                    ...state.input
                }
            };
            obj['input'] = { ...state['input'], border: '1px solid ' + action.borderColor };
            obj['input']['border'] = { ...state['input']['border'], [action.layer]: '1px solid ' + action.borderColor };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_FORM_SET_THEME_LINE_HEIGHT]: (state, action) => {
            let obj = {
                input: {
                    ...state.input
                }
            };
            obj['input'] = { ...state['input'], lineHeight: action.lineHeight };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_FORM_SET_THEME_BORDER_RADIUS]: (state, action) => {
            let obj = {
                input: {
                    ...state.input
                }
            };
            obj['input'] = { ...state['input'], borderRadius: action.borderRadius };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_FORM_SET_THEME_FONT_STYLE]: (state, action) => {
            let obj = {
                input: {
                    ...state.input
                }
            };
            obj['input'] = { ...state['input'], style: action.style };
            return { ...state, ...obj };
        },
        [ActionTypes.LOGIN_SET_THEME]: (state, action) => {
            if (action.theme.hasOwnProperty('input')) {
                return { ...state, input: action.theme.input };
            } else {
                return state;
            }
        },
        //TODO: temporary partial implementation of global reducer
        [ActionTypes.THEME_MODIFY_KEY]: (state, action) => {
            let pathCheck = action.path.split('.');
            if (pathCheck[0] === 'form') {
                pathCheck.shift();
                return merge({}, state, setPath({}, pathCheck, action.value));
            } else {
                return state;
            }
        }
    },
    initialState
);

export default formDataReducer;



// WEBPACK FOOTER //
// ./src/reducers/theme/data/form.js